import IndigoSymbol from "@assets/logos/indigo_symbol.svg?react";
import { Heading } from "@indigo-components";

interface AuthFlowHeaderProps {
  heading: string;
}

const AuthFlowHeader: React.FC<AuthFlowHeaderProps> = ({ heading }) => {
  return (
    <div className="design-system-signin-header">
      <div className="design-system-signin-logo-container">
        <IndigoSymbol
          role="img"
          aria-label="Indigo Logo"
          width={48}
          height={48}
        />
      </div>
      <Heading level={1}>{heading}</Heading>
    </div>
  );
};

export default AuthFlowHeader;
